<template>
	<Modal
		class="confirm-modal"
		:title="title"
		:closeable="isClosable"
		:open="isOpen"
		@close="handleCancel"
	>
		<!-- body -->
		<template #body>
			<slot name="body">
				<p v-html="body" />
			</slot>
		</template>

		<!-- footer -->
		<template #footer-buttons>
			<button
				v-if="cancelLabel && !isMobileWebApp"
				class="button button--secondary"
				@click="handleCancel"
			>
				{{ cancelLabel }}
			</button>
			<button
				class="button"
				:class="primaryBtnClass"
				@click="handleConfirm"
			>
				{{ confirmLabel }}
			</button>
		</template>
	</Modal>
</template>

<script>
import Modal from './Modal.vue';
import { mapGetters } from 'vuex';
export default {
	name:       'ConfirmModal',
	components: { Modal },
	props:      {
		title: {
			type:    String,
			default: '',
		},
		body: {
			type:    String,
			default: '',
		},
		cancelLabel: {
			type:    String,
			default: 'Cancel',
		},
		confirmLabel: {
			type:    String,
			default: 'Ok',
		},
		primaryBtnClass: {
			default: () => ['button--primary'],
		},
	},
	data() {
	  	return {
	  		isOpen: true,
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
		isClosable() {
			return !!this.isMobileWebApp;
		},
	},
	methods: {
		handleConfirm() {
	  		this.isOpen = false;
			this.$emit('confirm');
		},
		handleCancel() {
	  		this.isOpen = false;
			this.$emit('cancel');
		},
	},
};
</script>

<style lang="scss" scoped>

.confirm-modal::v-deep {
	.modal--body {
		padding-bottom: 24px;
	}
}

</style>
